import {FC, HTMLAttributes} from "react";
import {emptyfunc} from "../utils/AppFunction";

type Props = HTMLAttributes<any> & {
  label?: string;
  onClick?: () => void;
}

const BackButton: FC<Props> = (props) => {
  const {label = "Quay lại"} = props;
  return (
    <div
      style={{borderRight: "2px solid #eff2f5"}}
      className=" d-flex align-items-center spaces h-20">
      <button
        type="button"
        onClick={props.onClick ?? emptyfunc}
        className="btn btn-bg-transparent text-hover-primary ps-0 d-flex align-items-center py-2"
      >
        <svg
          width={24}
          height={24}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.99988 2.14552V20.783C2.99988 20.9036 3.09631 21 3.21416 21H4.82131C4.93916 21 5.03559 20.9036 5.03559 20.783V2.14552C5.03559 2.02499 4.93916 1.92856 4.82131 1.92856H3.21416C3.09631 1.92856 2.99988 2.02499 2.99988 2.14552ZM8.00881 11.2955C7.98319 11.3156 7.96248 11.3412 7.94824 11.3704C7.93399 11.3997 7.92659 11.4318 7.92659 11.4643C7.92659 11.4968 7.93399 11.5289 7.94824 11.5581C7.96248 11.5874 7.98319 11.613 8.00881 11.633L11.8043 14.633C11.8359 14.6578 11.8738 14.6731 11.9137 14.6773C11.9536 14.6815 11.9939 14.6744 12.0299 14.6568C12.066 14.6392 12.0963 14.6118 12.1175 14.5778C12.1388 14.5437 12.15 14.5044 12.1499 14.4643V12.4848H21.2142C21.332 12.4848 21.4284 12.3884 21.4284 12.2705V10.6634C21.4284 10.5455 21.332 10.4491 21.2142 10.4491H12.1526V8.46427C12.1526 8.28481 11.9463 8.1857 11.807 8.29552L8.00881 11.2955Z"
            fill="#343A40"
          />
        </svg>
        <span className="fw-500 ps-2">{label}</span>
      </button>
    </div>
  )
};

export default BackButton
